import { render } from "./BarangMasuk.vue?vue&type=template&id=2e782578&scoped=true"
import script from "./BarangMasuk.vue?vue&type=script&lang=js"
export * from "./BarangMasuk.vue?vue&type=script&lang=js"

import "./BarangMasuk.vue?vue&type=style&index=0&id=2e782578&scoped=true&lang=css"
import "./BarangMasuk.vue?vue&type=style&index=1&id=2e782578&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\INVENTORY BCK\\inventoryfe_bck\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e782578"]])

export default __exports__